module.exports = __webpack_public_path__ + "img/Quatsch.e365aaee.jpg";